import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Newsletter from "./Newsletter";
import Footer from "./Footer";
import { BsWhatsapp } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import VideoItem from "./VideoItem";

export default function Home() {

    const navi = useNavigate();

    const categories = [
        { title: "Black Jeans", image: "/images/12.jpg", badge: "BESTSELLER", description: "Made from premium stretch denim with a deep black finish, perfect for both casual and smart looks." },
        { title: "Denims", image: "/images/13.jpg", badge: "NEW ARRIVALS", description: "Stylish sky blue denim with a soft finish, perfect for a casual yet trendy look." },
        { title: "Triple Denim Pack", image: "/images/8.jpg", badge: "TRENDING", description: "A versatile trio of premium-fit jeans in stylish washes, perfect for every occasion." },
        { title: "Denims", image: "/images/10.jpg", description: "Athletic-inspired comfort with urban style. Perfect for workouts or casual wear." },
        { title: "Denims", image: "/images/121.jpg", description: "The perfect balance between shorts and pants for relaxed yet polished vibes." },
        { title: "Black Jeans", image: "/images/111.jpg", badge: "SUMMER EDIT", description: "Breathable fabrics and modern cuts. From casual to athletic styles for warmer days." },
    ];

    const videos = [
        { video: "/images/21.mp4" },
        { video: "/images/22.mp4" },
        { video: "/images/23.mp4" }
    ];

    const values = [
        { icon: '👖', title: 'Unmatched Comfort', text: ' Every piece is crafted with premium fabrics that feel as good as they look — whether you\'re at work, on a date, or just chilling.' },
        { icon: '✨', title: 'Effortless Style', text: 'Our designs blend classic tailoring with modern trends, helping you stay sharp without trying too hard.' },
        { icon: '🧵', title: 'Quality That Lasts', text: 'We don’t believe in fast fashion. Hack98 pieces are made to last — in both durability and timeless design.' },
        { icon: '💪', title: 'Made for Real Men', text: 'Whether you\'re built for suits or streetwear, we design for men of all shapes, sizes, and walks of life.' },
        { icon: '🔥', title: 'Confidence You Can Wear', text: 'When you wear Hack98, you’re not just wearing clothes — you’re wearing confidence, identity, and purpose.' },
    ];

    const stats = [
        { icon: '⭐', text: '5,000+ Happy Customers' },
        { icon: '💎', text: 'Premium Quality Hosiery Denim' },
        { icon: '🧼', text: 'Machine-Wash Friendly' },
        { icon: '🌱', text: 'Ethically Produced' },
    ];

    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    video.play().catch(() => { });
                } else {
                    video.pause();
                }
            },
            {
                threshold: 0.6,
            }
        );

        if (video) {
            observer.observe(video);
        }

        return () => {
            if (video) observer.unobserve(video);
        };
    }, []);

    return (
        <>
            <title>Hack98 | Wholesale Jeans & Denims for Men & Boys</title>
            <meta name="description" content="Discover premium wholesale jeans and denims for men and boys. Bulk supply, fast delivery, and trusted quality from Hack98." />
            <meta name="keywords" content="wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans,menswear near me, jeans near me, denims for men, denims for boys near me, 1 hack wholesale, 1 jeans denims, 1 men boysyou, 1 hack wholesale jeans, 1 denims men boysyou, 1 hack wholesale jeans denims, 1 men boysyou need enable" />

            <meta property="og:title" content="Hack98 | Premium Wholesale Jeans & Denims" />
            <meta property="og:site_name" content="hack98" />
            <meta property="og:url" content="https://hack98.club/" />
            <meta property="og:description" content="Hack98 delivers premium wholesale jeans & denims for men and boys. Bulk supply, reliable quality, and fast support for your denim business." />
            <meta property="og:image" content="logoo.png"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@hack98" />
            <meta name="twitter:description" content="Hack98 delivers premium wholesale jeans & denims for men and boys. Bulk supply, reliable quality, and fast support for your denim business" />
            <meta name="twitter:app:country" content="India" />

            <div className="navbarrrr" >
                <Navbar />
            </div>

            <section className="position-relative bg-dark text-white d-flex align-items-center justify-content-center min-vh-100 overflow-hidden">
                {/* Carousel Background */}
                <div className="position-absolute top-0 start-0 w-100 h-100 z-0">
                    <div className="vh-100">
                        <div id="mycaro" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">
                            <div className="carousel-inner">
                                <div className="carousel-item active carouselll">
                                    <img src="images/denims.jpeg" className="d-block w-100 img-fluid imgcarousel" alt="Slide 1" />
                                </div>

                                <div className="carousel-item carouselll">
                                    <img src="images/IMG_960.jpeg" className="d-block w-100 img-fluid imgcarousel" alt="Slide 2" />
                                </div>
                            </div>

                            {/* Carousel Controls */}
                            <button className="carousel-control-prev" type="button" data-bs-target="#mycaro" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#mycaro" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Hero Content */}
                <div className="container z-1">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="hero-content animate__animated animate__fadeIn">
                                <h1 className="display-4 fw-bold mb-3 text-shadow">Premium Wholesale Denims</h1>
                                <p className="fs-5 mb-4 text-shadow">
                                    Quality, Style & Affordability — Your trusted partner for men’s jeans, shorts, capris and denim wear across India.
                                </p>
                                <div className="d-flex flex-wrap gap-3">
                                    <Link to="/Products">
                                        <button className="btn btn-warning">
                                            View Catalog
                                        </button>
                                    </Link>
                                    <Link to="/Distributor">
                                        <button className="btn btn-outline-light">
                                            Become a Distributor
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button
                    className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open(
                            "https://wa.me/919517909090?text=Hi%2C%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me%3F",
                            "_blank"
                        )
                    }
                >
                    <BsWhatsapp size={24} />
                </button>
            </div>
            <section className="container">
                <div className="text-center mb-5 mt-5">
                    <h2 className="fw-bold text-dark">
                        Our Bestselling Products
                    </h2>
                    <p className="text-muted">Chase comfort chase style</p>
                </div>
                <div className="row g-4">
                    {categories.map((cat, index) => (
                        <div className="col-lg-2 col-md-4 col-sm-6 col-6 mb-5" key={index}>
                            <div className="category-card h-100 position-relative overflow-hidden rounded-4">
                                <img
                                    src={cat.image}
                                    alt={cat.title}
                                    className="img-fluid w-100 h-100 object-fit-cover"
                                />
                                <span className="badge badge-overlay">{cat.badge}</span>
                                <div className="category-overlay d-flex flex-column justify-content-end p-4">
                                    <h5 className="text-white fw-bold">{cat.title}</h5>
                                    <p className="text-light small">{cat.description}</p>
                                    <Link to="/Distributor">
                                        <button className="btn shop-btn mt-2">Send Enquiry</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <section className="py-5 bg-light mt-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold mb-2">Featured Collections</h2>
                        <p className="text-muted">Explore our latest seasonal collections</p>
                    </div>

                    <div className="row g-3">
                        {videos.map((item, index) => (
                            <div key={index} className="col-md-4 col-sm-6 col-12">
                                <div className="position-relative rounded overflow-hidden shadow videosss">

                                    <VideoItem item={item} />

                                    <div className="position-absolute top-0 start-0 w-100 h-100 videobg"></div>

                                    <div className="position-absolute bottom-0 start-0 p-3 text-white">
                                        <Link to="/Products">
                                            <button className="btn btn-light btn-sm fw-medium">
                                                View Collection
                                            </button>
                                        </Link>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="why-choose-section container py-5 px-3 px-lg-5">
                <h2 className="section-title text-center mb-5">Why Choose Hack98?</h2>

                <div className="row g-4">
                    {values.map((item, index) => (
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4" key={index}>
                            <div className="value-card h-100 p-4 text-center bg-white rounded shadow-sm">
                                <div className="value-icon fs-1 mb-3">{item.icon}</div>
                                <h3 className="value-title fs-5">{item.title}</h3>
                                <p className="value-text text-muted">{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="stats-section mt-5">
                    <h3 className="stats-title text-center mb-4">⚡ What You Get with Hack98:</h3>
                    <div className="row g-3">
                        {stats.map((stat, i) => (
                            <div className="col-12 col-sm-6 col-md-6" key={i}>
                                <div className="stat-item bg-light p-3 rounded d-flex align-items-center gap-3 h-100 shadow-sm">
                                    <span className="stat-icon fs-4 text-primary">{stat.icon}</span>
                                    <span className="fw-semibold text-dark">{stat.text}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>
        </>
    )
}